import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { CustomerDetailBanner } from "../../../blocks/heigh-educate-banner";
import { useTranslation } from "react-i18next";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { CustomerDetailIntro } from "../../../blocks/customer-detail-intro";
import { Footer } from "../../../components/FooterV2";
import { CustomerDetailChallenge } from "../../../blocks/customer-detail-challenge";
import { CustomerDetailIdea } from "../../../blocks/customer-detail-idea";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { Helmet } from "react-helmet";

export const CsdnPage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const challenges = [
    {
      title: t("customer.csdn.challenge.item1.title"),
      description: t("customer.csdn.challenge.item1.description"),
    },
    {
      title: t("customer.csdn.challenge.item2.title"),
      description: t("customer.csdn.challenge.item2.description"),
    },
    {
      title: t("customer.csdn.challenge.item3.title"),
      description: t("customer.csdn.challenge.item3.description"),
    },
  ];
  const ideas = [
    {
      title: t("customer.csdn.ideas.item1.title"),
      descript: t("customer.csdn.ideas.item1.subtitle"),
      icon: "authing-like",
    },
    {
      title: t("customer.csdn.ideas.item2.title"),
      descript: t("customer.csdn.ideas.item2.subtitle"),
      icon: "authing-insurance",
    },
    {
      title: t("customer.csdn.ideas.item3.title"),
      descript: t("customer.csdn.ideas.item3.subtitle"),
      icon: "authing-idcard",
    },
  ];
  return (
    <div className="csdn-page">
      <Helmet>
        <title>
          快速搭建社区平台的登录认证系统，实现One-ID统一身份管理策略｜CSDN x
          Authing
        </title>
      </Helmet>
      <Header mode="dark" defaltNav={true} />
      <CustomerDetailBanner
        title={t("customer.csdn.banner.title")}
        addtionTitle={t("customer.csdn.banner.addtionTitle")}
        subtitle={t("customer.csdn.banner.subtitle")}
        theme="#FC5531"
        imgUrl={"//files.authing.co/authing-website/customer-csdn-banner.png"}
      />
      <CustomerDetailIntro
        imgUrl="//files.authing.co/authing-website/customer-csdn-intro-1.png"
        alt="企业服务单点登录"
        content={
          <>
            <p>{t("customer.csdn.intro.descript1")}</p>
            <p>{t("customer.csdn.intro.descript2")}</p>
          </>
        }
      />
      <CustomerDetailChallenge challenges={challenges} theme={"#FC5531"} />
      <CustomerDetailIdea ideas={ideas} theme={"#FC5531"} />
      <CommonPageLink pagesLink={pagesLink} theme={"#FC5531"} />
      {/* <CustomerConsult /> */}
      <HomeTryOn hasBg />

      <Footer />
    </div>
  );
};
